// frontend/src/api.js
import { API_BASE } from "./config";
import { getAuthToken } from "./authToken"; // reads from localStorage OR bbtoken cookie

const HAS_BASE = !!API_BASE;

const buildUrl = (path, params = {}) => {
  const base = HAS_BASE ? API_BASE : window.location.origin;
  const url = new URL(path.startsWith("/") ? path : `/${path}`, base);
  for (const [k, v] of Object.entries(params || {})) {
    if (v !== undefined && v !== null) url.searchParams.set(k, String(v));
  }
  return url.toString();
};

async function handle(res) {
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const ct = res.headers.get("content-type") || "";
      if (ct.includes("application/json")) {
        const j = await res.json();
        if (Array.isArray(j?.detail)) {
          msg = j.detail.map((d) => d.msg || JSON.stringify(d)).join("; ");
        } else if (j?.detail) {
          msg = typeof j.detail === "string" ? j.detail : JSON.stringify(j.detail);
        } else if (j?.message) {
          msg = j.message;
        }
      } else {
        const t = await res.text();
        if (t) msg = t;
      }
    } catch {
      // keep default msg
    }
    throw new Error(msg);
  }
  const ct = res.headers.get("content-type") || "";
  return ct.includes("application/json") ? res.json() : res.text();
}

function withAuthHeaders(baseHeaders = {}) {
  const headers = new Headers(baseHeaders || undefined);
  if (!headers.has("Accept")) headers.set("Accept", "application/json");

  // Prefer Authorization header when we have a token
  const token = getAuthToken();
  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  return headers;
}

export async function authedGet(path, params = {}) {
  const res = await fetch(buildUrl(path, params), {
    method: "GET",
    headers: withAuthHeaders(),
    credentials: "include", // keeps cookie fallback if you ever add it
  });
  return handle(res);
}

export async function authedPost(path, body = {}, params = {}) {
  const headers = withAuthHeaders({ "Content-Type": "application/json" });
  const res = await fetch(buildUrl(path, params), {
    method: "POST",
    headers,
    body: JSON.stringify(body ?? {}),
    credentials: "include",
  });
  return handle(res);
}

/* ---------------- LinkedIn Prospects ----------------
   Usage:
     await getLinkedInProspects("zoho.com")
     await getLinkedInProspects("https://www.zapier.com/blog/...", { limit: 12 })
----------------------------------------------------- */
export function getLinkedInProspects(domainOrUrl, opts = {}) {
  const { limit } = opts;
  const s = (domainOrUrl || "").trim();

  const params = {};
  if (limit !== undefined && limit !== null) params.limit = limit;

  // Auto-detect domain vs full URL
  if (s) {
    if (s.includes("://")) params.url = s;  // full URL
    else params.domain = s;                 // bare domain/host
  }

  return authedGet("/prospects/linkedin", params);
}


export { buildUrl };
